import { Badge } from '@/components/ui/badge';
import { CONTRACT_STATUS_LABEL, getContractStatus, type ContractStatus } from '@/lib/contractStatus';

const VARIANT: Record<ContractStatus, 'success' | 'info' | 'muted'> = {
  active: 'success',
  upcoming: 'info',
  ended: 'muted',
};

export function ContractStatusBadge({ startDate, endDate }: { startDate: string | Date; endDate: string | Date }) {
  const status = getContractStatus(startDate, endDate);
  return <Badge variant={VARIANT[status]}>{CONTRACT_STATUS_LABEL[status]}</Badge>;
}
